import React, { FC } from 'react'

import { Box, Grid, Typography } from '@mui/material'
import { every } from 'lodash'
import { useTranslation } from 'react-i18next'

import { EmptyData } from '../EmptyData'
import { Indicators } from '../Indicators'
import { ReportWidgetsHeader } from '../ReportWidgetsHeader'
import { StyledWidgetWrapper } from '../StyledWidgetWrapper'
import { StressPerformanceType } from '../types'

import { CircularBarSection } from './CircularBarSection'

export const StressPerformanceWidget: FC<StressPerformanceType> = ({ positive, negative }) => {
  const { t } = useTranslation()

  const isNoData = every(
    [positive?.win, positive?.loss, negative?.win, negative?.loss],
    (value) => !value,
  )

  return (
    <StyledWidgetWrapper>
      <ReportWidgetsHeader
        text={t('stressPerformance', 'Stress-Performance')}
        explanation={t(
          'theGraphsRepresentTheComparisonOfWinAndLossTransactions',
          'The graphs represent the comparison of "Win" and "Loss" transactions',
        )}
      >
        <Indicators positiveLabel={t('win', 'Win')} negativeLabel={t('loss', 'Loss')} />
      </ReportWidgetsHeader>
      {isNoData ? (
        <Box mt={4}>
          <EmptyData
            title={t('notEnoughData', 'Not enough data')}
            subtitle={t('pleaseCompleteJournalingSection', 'Please complete "Journaling" section')}
          />
        </Box>
      ) : (
        <Grid container spacing={2} alignItems="center" height="100%" ml={0} minWidth={0}>
          <Grid item xs={12} sm={6} minWidth={0}>
            <CircularBarSection
              title={t('positive', 'Positive')}
              positiveVal={positive?.win}
              negativeVal={positive?.loss}
              positiveLabel={t('win', 'Win')}
              negativeLabel={t('loss', 'Loss')}
              positiveTextComponent={
                <Typography variant="h4">{`${Math.round(positive?.win)}%`}</Typography>
              }
              negativeTextComponent={
                <Typography variant="h4">{`${Math.round(positive?.loss)}%`}</Typography>
              }
            />
          </Grid>

          <Grid item xs={12} sm={6} minWidth={0}>
            <CircularBarSection
              title={t('negative', 'Negative')}
              positiveVal={negative?.win}
              negativeVal={negative?.loss}
              positiveLabel={t('win', 'Win')}
              negativeLabel={t('loss', 'Loss')}
              positiveTextComponent={
                <Typography variant="h4">{`${Math.round(negative?.win)}%`}</Typography>
              }
              negativeTextComponent={
                <Typography variant="h4">{`${Math.round(negative?.loss)}%`}</Typography>
              }
            />
          </Grid>
        </Grid>
      )}
    </StyledWidgetWrapper>
  )
}
